import { Checkbox, CheckboxProps } from '@systemeio/ui'
import {
  Controller,
  ControllerProps,
  FieldPath,
  FieldValues,
  PathValue,
  UseFormSetValue,
} from 'react-hook-form'

type CheckboxRhfProps<TValues extends FieldValues, TName extends FieldPath<TValues>> = Omit<
  CheckboxProps,
  'onChange' | 'value'
> &
  Omit<ControllerProps<TValues, TName>, 'render'> & {
    setValue: UseFormSetValue<TValues>
    afterChange?: (value: boolean) => void
  }

function CheckboxRhf<TValues extends FieldValues, TName extends FieldPath<TValues>>(
  props: CheckboxRhfProps<TValues, TName>,
) {
  const { setValue, control, name, rules, afterChange, ...restProps } = props

  const handleChange = (value: boolean) => {
    setValue(name, value as PathValue<TValues, TName>)
    afterChange?.(value)
  }

  return (
    <Controller
      control={control}
      name={name}
      rules={rules}
      render={({ field }) => (
        <Checkbox {...restProps} value={field.value} onChange={handleChange} />
      )}
    />
  )
}

export default CheckboxRhf
